module.exports = __webpack_public_path__ + "media/bootstrap-icons/gear-wide-connected-b7fd38a1.svg";